'use client';

import { getGoogleFontOptions } from '@/collections/settings/fonts/google';
import { SelectInput, useField } from '@payloadcms/ui';
import { useMemo } from 'react';

import type { TextFieldClientProps } from 'payload';

interface FontOption {
  label: string;
  value: string;
}

const GoogleFontFieldComponent = ({ path, field }: TextFieldClientProps) => {
  const { value, setValue } = useField<string>({ path });

  const options = useMemo(() => {
    const fonts = getGoogleFontOptions() as FontOption[];
    return fonts.map((font) => ({
      label: font.label,
      value: font.value,
    }));
  }, []);

  const label = typeof field.label === 'string' ? field.label : 'Google Font';

  return (
    <div>
      <label className="field-label">{label}</label>
      <SelectInput
        path={path}
        name={path}
        options={options}
        value={value}
        onChange={(option) => {
          if (option && !Array.isArray(option)) {
            setValue(option.value as string);
          }
        }}
      />
    </div>
  );
};

export default GoogleFontFieldComponent;
